export default "__VITE_ASSET__ln8R4pE8__"